import React from "react";
import { SelectInput, TextInput } from "react-admin";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// ✅ Custom numeric font sizes
const Size = ReactQuill.Quill.import("attributors/style/size");
Size.whitelist = [
  "8px",
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "32px",
];
ReactQuill.Quill.register(Size, true);

const LetterFormFields = ({
  companies,
  selectedCompany,
  setSelectedCompany,
  type,
  setType,
  subject,
  setSubject,
  direction,
  setDirection,
  body,
  setBody,
  generating,
  referenceNo,
  date,
}) => {
  // 🔹 Standard type mapping
  const typeCodeMap = {
    "Warning Letter": "WL",
    "Offer Letter": "OF",
    "Transport Contract": "TC",
    "Salary Certificate": "SC",
    "Employment Letter": "EL",
    "Experience Letter": "EX",
    "Termination Letter": "TL",
    "Promotion Letter": "PL",
    "Transfer Letter": "TR",
  };

  // ✅ Quill toolbar setup (numeric size dropdown)
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ size: Size.whitelist }], // numeric size dropdown
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ direction: "rtl" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "align",
    "direction",
    "link",
  ];

  return (
    <>
      {/* 🔹 Company + Type selectors */}
      <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
        <SelectInput
          source="company"
          label="Company"
          choices={companies.map((c) => ({ id: c.id, name: c.name }))}
          fullWidth
          onChange={(e) => setSelectedCompany(e.target.value)}
        />

        <div style={{ width: "100%" }}>
          <label style={{ fontWeight: 600 }}>Letter Type</label>
          <input
            list="letter-type-list"
            value={type}
            onChange={(e) => setType(e.target.value)}
            placeholder="Select or type a new type..."
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "14px",
              marginTop: "4px",
            }}
          />
          <datalist id="letter-type-list">
            {Object.keys(typeCodeMap).map((key) => (
              <option key={key} value={key} />
            ))}
          </datalist>
        </div>
      </div>

      {/* 🔹 Direction selector */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontWeight: 600 }}>Text Direction</label>
        <select
          value={direction}
          onChange={(e) => setDirection(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
            marginTop: "4px",
          }}
        >
          <option value="ltr">English (Left to Right)</option>
          <option value="rtl">Arabic (Right to Left)</option>
        </select>
      </div>

      {/* 🔹 Subject input */}
      <TextInput
        source="subject"
        label="Subject"
        fullWidth
        onChange={(e) => setSubject(e.target.value)}
      />

      {/* 🔹 Rich Text Editor */}
      <div style={{ marginTop: 16, marginBottom: 20 }}>
        <label style={{ fontWeight: "bold", marginBottom: 6 }}>Letter Body</label>
        <ReactQuill
          theme="snow"
          value={body}
          onChange={setBody}
          modules={quillModules}
          formats={quillFormats}
          style={{
            height: 240,
            background: "#fff",
            direction: direction,
            textAlign: direction === "rtl" ? "right" : "justify",
          }}
        />
      </div>

      {/* 🔹 Reference info */}
      <div
        style={{
          textAlign: "center",
          margin: "15px 0 20px",
          color: "#333",
          fontWeight: 600,
        }}
      >
        📄 Reference:{" "}
        <span style={{ color: "#1976d2" }}>
          {generating ? "Generating..." : referenceNo || "Auto"}
        </span>
        <br />
        📅 Date: {date}
      </div>
    </>
  );
};

export default LetterFormFields;
